import createReducer from '../../utils/createReducer';

const initialState = {};

export default createReducer(initialState, {});



// WEBPACK FOOTER //
// ./src/universal/redux/modules/renderOptions.js